















































































































































import {
  Component,
  Vue
} from "@/shared/vuepack";
import Logo from "@/shared/components/Logo.vue";
import * as RouteNames from "@/employee/route-names";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import {
  FetchState,
  InvestmentManagementType,
} from "@/shared/types";
import { formatCurrency } from "@/shared/currency";
import { useEnrollmentStore } from "@/employee/store/enrollment";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useUserStore } from "@/shared/store/user";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    Logo,
    GenericLoadingSpinner
  }
})
export default class AvidiaTermsFeeSchedule extends Vue {
  InvestmentManagementType = InvestmentManagementType;

  userStore = useUserStore();
  enrollmentStore = useEnrollmentStore();
  custodianSettingsStore = useCustodianSettingsStore();
  portalCustomizationStore = usePortalCustomizationStore();
  drivewealthStore = useDrivewealthStore();

  formatCurrency = formatCurrency;

  get quarterlyStatementFee () {
    return `${formatCurrency(this.custodianSettingsStore.quarterlyPaperStatementFee)}`;
  }

  get monthlyAdminFee () {
    return `${formatCurrency(this.enrollmentStore.feeSchedule.monthlyFeeAmount)}`;
  }

  get showFeeWaiverDisclaimer () {
    return this.enrollmentStore.showWaiver
    && (this.userStore.isIndividualAccountType
    || this.enrollmentStore.feeSchedule.isEmployerBalanceFeeWaiverEnabled);
  }

  get scrollContents () {
    return this.$route.name !== RouteNames.FeeSchedulePrint;
  }

  get showLoadingSpinner () {
    return this.enrollmentStore.feeScheduleFetchState !== FetchState.Loaded || !this.portalCustomizationStore.isSupportInfoLoaded;
  }

  get partnerName () {
    return this.portalCustomizationStore.supportInfo.displayName;
  }

  annualFee (managedType: InvestmentManagementType): string {
    if (this.enrollmentStore.feeScheduleFetchState !== FetchState.Loaded) {
      return "";
    }
    const accountFees = this.enrollmentStore.investmentFeeForAccountType(managedType);

    if (accountFees.annualBasis === 0) {
      return "No Fee";
    }

    let result = (accountFees.annualBasis / 100).toFixed(2) + "% of AUA";

    if (accountFees.quarterlyMaximum === 0 && accountFees.quarterlyMinimum === 0) {
      return result;
    }
    result = result + " (";
    if (accountFees.quarterlyMinimum !== 0) {
      result = result + "Min. " + formatCurrency(accountFees.quarterlyMinimum * 4);
    }
    if (accountFees.quarterlyMinimum !== 0 && accountFees.quarterlyMaximum !== 0) {
      result = result + "; ";
    }
    if (accountFees.quarterlyMaximum !== 0) {
      result = result + "Max. " + formatCurrency(accountFees.quarterlyMaximum * 4);
    }
    return result + ")";
  }

  get hasSelectAccount (): boolean {
    return this.drivewealthStore.allowedInvestmentAccountTypes.hasAdvisory;
  }

  get hasManagedAccount (): boolean {
    return this.drivewealthStore.allowedInvestmentAccountTypes.hasRiaManaged;
  }

  get hasChoiceAccount (): boolean {
    return this.drivewealthStore.allowedInvestmentAccountTypes.hasSelfDirected;
  }

  mounted () {
    this.enrollmentStore.loadFeeWaiverSettings(this.portalCustomizationStore.partnerId);
    this.enrollmentStore.loadFees();
    this.custodianSettingsStore.getCustodianSettings();
    this.drivewealthStore.loadAllowedInvestmentAccountTypes();
  }
}
